import useFetch from 'elements/Hooks/useFetch'
import List from '../../../components/Corporate/Requisitions/List'
import PageTitle from '../../../elements/PageTitle'
import { Breadcrumb, Card, Layout, message, Row } from 'antd'
import React, { Fragment } from 'react'
import useFetchList from '../../../elements/Hooks/useFetchList'
import { RequisitionsApi } from '../../../api/Corporates/Requisitions'
import useModalData from '../../../elements/Hooks/useModalData'
import { isEmpty, pick } from 'lodash'
import { withRouter } from 'react-router-dom'
import useFetchObject from '../../../elements/Hooks/useFetchObject'
import useTitle from '../../../elements/Hooks/useTitle'
import useListCompanyFilter from '../../../elements/Hooks/useListCompanyFilter'
import RequisitionsModal from '../../../components/Corporate/Requisitions/RequisitionsModal'

const { Content } = Layout

function RequisitionsCont(props) {
  const select = '_id,_key,code,company,sales,title,owner,type,currency,converted,toBill,date,status'
  const { data, fetching, fetch } = useFetch({ url: `requisitions/?select=${select}`, queryKey: 'requisitions' })

  const { list, company, onChangeCompany } = useListCompanyFilter(data, fetching)

  useTitle('Requisitions')
  const {
    visible,
    modalType,
    object: req,
    setObject: setRequisition,
    submitting,
    submit,
    removing,
    remove,
    formRef,
    onShow,
    onCancel,
    update,
  } = useModalData(
    RequisitionsApi.create,
    RequisitionsApi.update,
    RequisitionsApi.remove,
    fetch,
    undefined,
    undefined,
    (key) => {
      props.history.replace({
        pathname: `/purchasing/requisitions/${key}/update`,
      })
    }
  )
  const { fetch: fetchRequisition, fetching: fetchingRequisition, data: requisition } = useFetch({
    url: `requisitions/${req._key}?select=*`,
    dependencyArray: [req._rev],
    dontFetch: isEmpty(req),
  })

  return (
    <Requisitions
      {...{
        list,
        fetching,
        submitting,
        visible,
        fetch,
        fetchRequisition,
        fetchingRequisition,
        requisition,
        onShow,
        onCancel,
        submit,
        removing,
        remove,
        update,
        modalType,
        formRef,
        company,
        onChangeCompany,
      }}
    />
  )
}

function Requisitions(props) {
  return (
    <Fragment>
      <Content style={{ margin: '0px 0px' }}>
        <Card>
          <Row>
            <Breadcrumb>
              <Breadcrumb.Item href="/#/purchasing/requisitions/">Purchasing</Breadcrumb.Item>
              <Breadcrumb.Item>Requisitions</Breadcrumb.Item>
            </Breadcrumb>
            <PageTitle title={'Requisitions'} subtitle={'Requisitions'} color={'#633570'} iconType={'message'} />
          </Row>
        </Card>
        <Row style={{ padding: 10 }}>
          <Card>
            <RequisitionsModal {...props} />
            <List {...props} />
          </Card>
        </Row>
      </Content>
    </Fragment>
  )
}

Requisitions.propTypes = {}
Requisitions.defaultProps = {}

export default withRouter(RequisitionsCont)
